// 全屏-柜体总体数据
<template>
  <div class="DkbFCabinet">
    柜体总体数据内容
  </div>
</template>

<script>
  import { localUserInfo, showToast } from "../../../../static/js/utility/utility.js"
  let vm

  export default {
    name: 'DkbFCabinet',
    components: {
    },
    data () {
      return {
      }
    },
    created () {
      vm = this
   
    },
    mounted() {
      // console.log('route', this.$route)
    },
    computed: {
    },
    methods: {
    },
    watch: {
    }
  }
</script>

<style lang="scss" scoped>
.DkbFCabinet {

}
</style>



// WEBPACK FOOTER //
// src/components/DkbPage/FScreen/Cabinet.vue